<template>
  <div class="connection-card">
    <div class="legend-line" :style="{ backgroundColor: legendColorForActor(connection) }" />
    <router-link :to="'/actors/' + connection.id">
      {{ connection.name }}
    </router-link>

    <div class="card-buttons">
      <a
        href="#"
        @click="handleClickEdit($event)"
        v-if="! ['subsidiaries', 'main_company'].includes(relation)"
      >
        <icon name="edit" size="extra-small" />
      </a>
      <a
        class="remove-link"
        href="#"
        @click="handleRemoveRelation($event)"
        v-if="! ['subsidiaries', 'main_company'].includes(relation)"
      >
        <icon name="trash" size="extra-small" />
      </a>
    </div>
  </div>
</template>

<script>
import Dropdown from '../../Dropdown/Dropdown.vue'
import FiltersMixin from '../../../util/FiltersMixin'

export default {
  data () {
    return {
      editVisible: false,
      relation: this.connection.type,
    }
  },
  props: {
    connection: Object,
    remove: Function,
    edit: Function,
  },
  mixins: [FiltersMixin],
  components: {
    Dropdown,
  },
  computed: {
    ecosystemRelationships () {
      return this.$store.getters.fullActorRelationships
    },
  },
  methods: {
    handleClickEdit (e) {
      e.preventDefault()
      this.$emit('edit', this.connection)
    },
    handleRemoveRelation (e) {
      e.preventDefault()
      this.$emit('remove')
    },
  },
}
</script>

<style lang="scss" scoped>
.connection-card {
  align-items: center;
  background: #fff;
  border: 1px solid #f1f3f5;
  border-radius: 10px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, .03);
  display: flex;
  margin-bottom: 8px;
  overflow: hidden;
  padding: 0 8px 0 20px;
  position: relative;
  transition: box-shadow .15s ease, border-color .15s ease;

  &:hover {
    border-color: #e2e6ea;
    box-shadow: 0 2px 6px rgba(0, 0, 0, .06);
  }

  a {
    color: #4a4f5c;
    text-decoration: none;
  }
}

.legend-line {
  bottom: 0;
  left: 0;
  position: absolute;
  top: 0;
  width: 10px;
}

.card-buttons {
  margin-left: auto;

  a {
    color: #a7abb5;

    &:hover {
      color: #4a4f5c;
    }
  }
}

.edit-popup {
  background-color: white;
  border: 1px solid #dadada;
  left: -1px;
  padding: 10px 5px 5px;
  position: absolute;
  right: -1px;
  top: 100%;
  z-index: 1;

  .form-group {
    margin-bottom: 5px;
  }
}
</style>
